module.exports = __webpack_public_path__ + "static/3-302881f290c1fd7de561bb257f24584f.png";